import { SActionBtn, SIDRender, SLowcodeList, SMessage, STableActions, STags, SListTabs } from 'shj-components'
import styles from './index.module.less'
import { useRef, useState } from 'react'
import { config } from './config'
import { getTenantId } from '@/common/utils'
import { useNavigate } from 'react-router-dom'
import {
  addPaymentApplyForOrder,
  cancelOrder,
  getOrderList,
  orderOpreation,
} from '@/services/order'
import { Button, message, Modal, QRCode, Tag } from 'antd'
import { getEnums } from '@/services/homeService'
import { KeepAlive } from 'react-activation'

export default function OrderService() {
  const listRef = useRef<any>(null)
  const statusRef = useRef<any>('')
  const tenantId = getTenantId()
  const [orderStatusList, setOrderStatusList] = useState<Array<any>>([{
    label: '全部',
    key: '',
  }])
  const navigate = useNavigate()

  const fetchList = async values => {
    try {
      const { current, pageSize, ...rest } = values
      const data: any = await getOrderList({
        params: { pageId: current, pageSize },
        data: {...rest.query, status: statusRef?.current},
      })
      console.log(data)
      return { records: data.list, total: data.count, success: true }
    } catch (err) {
      return { success: false };
    }
  }

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return orderOpreation({ data: { id } }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }
  //  表格事件: 删除
  const onCancel = id => {
    SMessage.confirm({
      onOk: () => {
        return cancelOrder({ params: { orderId: id } }).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
      title: '确认取消订单？',
      content: '',
    })
  }
  const clickToView = (record, auth) => {
    if (record.dealMode === 'DIRECT') {
      // 直接付款详情
      window.open(`/order/list/details/direct-index/${record.id}`)
    } else {
      // 签约付款详情
      window.open(`/order/list/details/${record.id}`)
    }
  }
  const showQRcode = async (record: any) => {
    let res = await addPaymentApplyForOrder({
      data: {
        customerId: record.customerId,
        orderIdList: [record.id],
      },
    })
    const currentDomain = window.location.origin
    const copyLink = `${currentDomain}/h5/#/pages/payment/index?orderId=${res.paymentOrderId}&tenantId=${tenantId}`
    Modal.info({
      title: '收款二维码已生成，请使用手机扫一扫完成支付！',
      closable: true,
      icon: null,
      content: (
        <div style={{ padding: '30px 0 15px 0', textAlign: 'center' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 15 }}>
            <QRCode value={copyLink} />
          </div>
          <Button
            color="primary"
            variant="filled"
            onClick={() => {
              navigator.clipboard.writeText(copyLink).then(() => {
                message.success('复制成功')
              })
            }}
          >
            复制链接
          </Button>
        </div>
      ),
      footer: null,
    })
  }
  const getOptions = async () => {
    const bizOpTypeEnum = await getEnums('plus-crm', 'com.shj.saas.plus.crm.enums.BizOpTypeEnum')
    const orderStatusEnum = await getEnums(
      'plus-trade',
      'com.shj.saas.plus.trade.enums.OrderStateEnum'
    )
    if (Array.isArray(orderStatusEnum)) {
      const list = orderStatusEnum?.map((item: any) => ({ label: item?.description, key: item?.key }))
      setOrderStatusList([{ label: '全部', key: '' }, ...list]);
    }
    return Promise.resolve({ bizOpTypeEnum, orderStatusEnum })
  }
  const clickToOrder = () => {
    window.open('/deal/basetd/understand/online-shop?onlyBuy=true')
  }

  const handleChangeTab = (tab: any) => {
    statusRef.current = tab;
    listRef?.current?.resetPagination()
    listRef?.current?.reload();
  }

  const extensions = {
    request: { fetchList, getOptions },
    events: {
      clickToView,
      clickToOrder,
    },
    status: {
      selectedDisabled: ({ selectedRowKeys }: any) => !selectedRowKeys.length,
      radioDisabled: ({ selectedRowKeys }: any) => selectedRowKeys.length !== 1,
    },
    customRender: {
      SIDRender(text: any, record: any) {
        return (
          <SIDRender
            id={text}
            onClick={hasAuth => clickToView(record, hasAuth)}
            copy={true}
            // auth={'orderJumpDetails'}
          ></SIDRender>
        )
      },
      statusRender(text: any, record: any) {
        return <STags itemKey={text} />
      },
      bizTagRender(text: any, record: any) {
        return (
          <STags itemKey={text} />
        )
      },
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
            {/* <SActionBtn onClick={() => clickToView(record, 'auth')}>详情</SActionBtn> */}
            {/* // BtnAuth[record.dealMode]??[record.status]?.map((item: any) => { */}
            {/* //   console.log(item)
              // return ( */}
            {record.cancelFlag && <SActionBtn onClick={() => onCancel(record.id)}>取消</SActionBtn>}
            {/* {record.status === 'expired' && (
              <SActionBtn danger onClick={() => onDel(record.id)}>
                删除
              </SActionBtn>
            )} */}
            {record.status === 'waitPay' && (
              <SActionBtn onClick={() => showQRcode(record)}>收款二维码</SActionBtn>
            )}
          </STableActions>
        )
      },
    },
  }
  return (
    <KeepAlive name={location.pathname}>
      <div>
        <SListTabs defaultActiveKey={''} items={orderStatusList} hideExtra={false} onChange={handleChangeTab} />
        <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
      </div>
    </KeepAlive>
  )
}
